<div class="w-full py-3 px-2 sm:px-4">
  <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-3">
    <div class="flex items-center justify-start gap-1 lg:gap-2">
      <!-- Back Button SVG (clickable) -->
      <svg class="size-6 cursor-pointer shrink-0" [routerLink]="['/product-tagging']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_848_1764" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
          height="24">
          <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
      </svg>
      <img class="size-7 sm:size-8 lg:size-10" src="/assets/images/stock/ready-product.png" alt="Tagging"
        *ngIf="titleTag" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444" *ngIf="titleTag">Tagged Product List</span>
    </div>
    <div></div>
  </div>

  <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
    <!-- Rows and Search Container -->
    <div class="flex flex-wrap items-center justify-center md:justify-start gap-2 sm:gap-4 w-full md:w-auto">
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label for="rowFilter" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Rows :
        </label>
        <div class="relative">
          <select id="rowFilter" [(ngModel)]="itemsPerPage" (change)="filterTable()"
            class="border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725 bg-white">
            <option *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]" [value]="count">
              {{ count }}
            </option>
          </select>
          <div class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none">
            <svg width="10" height="5" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
            </svg>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2 flex-grow sm:flex-grow-0">
        <label for="globalSearch" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Search :
        </label>
        <input id="globalSearch" type="text" [(ngModel)]="globalSearchText" (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-full md:w-48 lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725"
          autocomplete="off" />
      </div>
    </div>

    <!-- Action Buttons Row -->
    <div class="flex items-center flex-wrap justify-center md:justify-end gap-2 w-full md:w-auto">
      <button
        class="flex-1 sm:flex-none flex items-center justify-center gap-1 text-[#F20707] border-1 border-[#F20707] bg-[#fff6f3] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadPDF()">
        <svg class="size-4 xl:hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_iconCarrier">
            <path
              d="M12 16L11.2929 16.7071L12 17.4142L12.7071 16.7071L12 16ZM13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L13 4ZM5.29289 10.7071L11.2929 16.7071L12.7071 15.2929L6.70711 9.29289L5.29289 10.7071ZM12.7071 16.7071L18.7071 10.7071L17.2929 9.29289L11.2929 15.2929L12.7071 16.7071ZM13 16L13 4L11 4L11 16L13 16Z"
              fill="#F20707"></path>
            <path d="M5 21L19 21" stroke="#F20707" stroke-width="2"></path>
          </g>
        </svg>
        <span class="hidden xl:block">Download</span>PDF
      </button>
      <button
        class="flex-1 sm:flex-none flex items-center justify-center gap-1 text-[#029921] border-1 border-[#029921] bg-[#e6ffe6] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadExcel()">
        <svg class="size-4 xl:hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_iconCarrier">
            <path
              d="M12 16L11.2929 16.7071L12 17.4142L12.7071 16.7071L12 16ZM13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L13 4ZM5.29289 10.7071L11.2929 16.7071L12.7071 15.2929L6.70711 9.29289L5.29289 10.7071ZM12.7071 16.7071L18.7071 10.7071L17.2929 9.29289L11.2929 15.2929L12.7071 16.7071ZM13 16L13 4L11 4L11 16L13 16Z"
              fill="#029921"></path>
            <path d="M5 21L19 21" stroke="#029921" stroke-width="2"></path>
          </g>
        </svg>
        <span class="hidden xl:block">Download</span>Excel
      </button>
      <button
        class="flex-1 sm:flex-none flex items-center justify-center gap-1 text-[#0720EC] border-1 border-[#0720EC] bg-[#E8E6FF] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadJSONAll()">
        <svg class="size-4 xl:hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_iconCarrier">
            <path
              d="M12 16L11.2929 16.7071L12 17.4142L12.7071 16.7071L12 16ZM13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L13 4ZM5.29289 10.7071L11.2929 16.7071L12.7071 15.2929L6.70711 9.29289L5.29289 10.7071ZM12.7071 16.7071L18.7071 10.7071L17.2929 9.29289L11.2929 15.2929L12.7071 16.7071ZM13 16L13 4L11 4L11 16L13 16Z"
              fill="#0720EC"></path>
            <path d="M5 21L19 21" stroke="#0720EC" stroke-width="2"></path>
          </g>
        </svg>
        <span class="hidden xl:block">Download</span>JSON
      </button>
      <button
        class="flex-1 sm:flex-none flex items-center justify-center gap-1 text-[#00ad94] border-1 border-[#00ad94] bg-[#e5fffb] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadCSV()">
        <svg class="size-4 xl:hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_iconCarrier">
            <path
              d="M12 16L11.2929 16.7071L12 17.4142L12.7071 16.7071L12 16ZM13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L13 4ZM5.29289 10.7071L11.2929 16.7071L12.7071 15.2929L6.70711 9.29289L5.29289 10.7071ZM12.7071 16.7071L18.7071 10.7071L17.2929 9.29289L11.2929 15.2929L12.7071 16.7071ZM13 16L13 4L11 4L11 16L13 16Z"
              fill="#00ad94"></path>
            <path d="M5 21L19 21" stroke="#00ad94" stroke-width="2"></path>
          </g>
        </svg>
        <span class="hidden xl:block">Download</span>CSV
      </button>

      <div class="relative inline-block text-left flex-1 sm:flex-none">
        <button (click)="toggleDropdown()"
          class="w-full text-[#B92185] border-1 border-[#B92185] bg-[#FFE1F5] font-medium text-xs lg:text-sm px-2 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition">
          Visibility
        </button>

        <div *ngIf="showDropdown" class="absolute z-[100] mt-2 p-4 bg-white border rounded shadow-2xl right-0 sm:-left-24 w-64 max-h-80 overflow-y-auto">
          <p class="font-bold text-sm mb-2 border-b pb-1">Visible Columns:</p>

          <label *ngFor="let field of selectedFields" class="flex items-center gap-2 text-sm mb-2 cursor-pointer hover:bg-gray-50 rounded p-1">
            <input type="checkbox" [(ngModel)]="field.selected" (change)="onFieldToggle(field)" autocomplete="off" class="rounded text-c19725" />
            {{ field.label }}
          </label>

          <div class="mt-3 border-t pt-2 flex flex-col gap-2">
            <button (click)="selectAllFields()" class="text-xs text-blue-600 hover:underline text-left">Select All</button>
            <button (click)="deselectAllFields()" class="text-xs text-red-800 hover:underline text-left">Deselect All</button>
            <button (click)="restoreColumnSelection()" class="text-xs text-gray-600 hover:underline text-left">Restore Defaults</button>

            <button (click)="applyColumnSelection()"
              class="mt-2 bg-blue-600 text-white text-xs font-bold py-2 rounded-[5px] hover:bg-blue-700 transition">
              Apply Changes
            </button>
          </div>
        </div>
      </div>
      <button (click)="printTable()"
        class="flex-1 sm:flex-none text-[#5606b6] border-1 border-[#5606b6] bg-[#ecddff] font-medium text-xs lg:text-sm px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition">
        Print
      </button>
    </div>
  </div>


  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar border border-[#D9D9D9] rounded-md mt-6 shadow-sm">
    <table
      class="w-full table border-collapse border-spacing-0 bg-white overflow-hidden">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th class="p-2 font-medium text-center border-r border-gray-300 w-12">
            No.
          </th>
          <th *ngFor="let field of selectedFields" [hidden]="!field.selected"
            class="p-2 font-medium text-left border-r border-gray-300">
            <div class="flex flex-col gap-1 w-32 sm:w-40 lg:w-48">
              <input type="text" [(ngModel)]="searchValues[field.key]" (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()" [attr.placeholder]="'Search ' + field.label"
                class="border border-dcdcdc p-1.5 rounded-[5px] text-xs w-full focus:outline-none focus:border-c19725 font-normal" autocomplete="off" />

              <div class="text-xs font-bold flex items-center gap-1 cursor-pointer select-none uppercase tracking-tight"
                (click)="sortBy(field.key)">
                {{ field.label }}
                <svg *ngIf="sortKey === field.key" class="w-3 h-3 text-c19725" viewBox="0 0 24 24">
                  <path *ngIf="sortDirection === 'asc'" d="M12 8l6 6H6z" fill="currentColor" />
                  <path *ngIf="sortDirection === 'desc'" d="M12 16l-6-6h12z" fill="currentColor" />
                </svg>
              </div>
            </div>
          </th>

          <th class="p-2 font-medium text-center w-24">
            Action
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm">
        <tr class="hover:bg-gray-50 transition-colors"
          *ngFor="let tag of paginatedTaggingsList; let i = index">
          <td class="p-3 text-center border-r border-b border-[#D9D9D9] text-gray-500 font-medium">
            {{ (currentPage - 1) * itemsPerPage + i + 1 }}
          </td>

          <ng-container *ngFor="let field of selectedFields">
            <td *ngIf="field.selected" class="p-3 border-r border-b border-[#D9D9D9] text-gray-700">
              <ng-container *ngIf="field.key === 'tag_image'; else otherField">
                <div class="flex justify-center">
                  <img *ngIf="tag.tag_image" [src]="tag.tag_image" alt="Tag Image"
                    class="w-10 h-10 object-cover rounded border border-gray-100 shadow-sm" />
                </div>
              </ng-container>
              <ng-template #otherField>
                {{ getDisplayValue(getNestedValue(tag, field.key)) || "-" }}
              </ng-template>
            </td>
          </ng-container>

          <td class="p-3 text-center border-b border-[#D9D9D9]">
            <div class="flex items-center justify-center gap-2 sm:gap-3">
              <button class="cursor-pointer p-1 hover:bg-gray-100 rounded transition" (click)="viewTag(tag)" title="View">
                <svg class="size-5 sm:size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.5 12C3.6 7.5 7.5 4.5 12 4.5C16.5 4.5 20.4 7.5 22.5 12C20.4 16.5 16.5 19.5 12 19.5C7.5 19.5 3.6 16.5 1.5 12Z"
                    stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

              <button class="cursor-pointer p-1 hover:bg-red-50 rounded transition" (click)="deleteTag(tag.std_id)" title="Delete">
                <svg class="size-5 sm:size-6" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="paginatedTaggingsList.length === 0">
          <td [attr.colspan]="selectedFields.length + 2"
            class="p-10 text-center border-b border-[#D9D9D9] text-gray-400 italic">
            No tags found matching your search.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex flex-col sm:flex-row items-center justify-between border-t border-gray-200 bg-white py-4 gap-4">
    <div class="text-xs text-gray-500 italic">
      Page {{currentPage}} of {{totalPages}}
    </div>
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav class="isolate inline-flex gap-1 sm:gap-2 -space-x-px rounded-md" aria-label="Pagination">
          <button (click)="goToPreviousPage()" [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:pointer-events-none transition-all">
            <span class="sr-only">Previous</span>
            <svg class="size-5 md:size-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd" />
            </svg>
          </button>
          
          <div class="flex gap-1 overflow-x-auto max-w-[150px] sm:max-w-none no-scrollbar">
            <ng-container *ngFor="let page of pageNumbers">
              <ng-container *ngIf="page !== -1; else ellipsis">
                <button (click)="goToPage(+page)" [class.bg-c19725]="currentPage === page"
                  [class.text-white]="currentPage === page"
                  class="relative z-10 inline-flex items-center justify-center min-w-[32px] md:min-w-[36px] h-8 md:h-9 rounded-[5px] text-sm font-bold text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 transition-all">
                  {{ page }}
                </button>
              </ng-container>
              <ng-template #ellipsis>
                <span
                  class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 text-sm font-normal text-gray-400">...</span>
              </ng-template>
            </ng-container>
          </div>

          <button (click)="goToNextPage()" [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:pointer-events-none transition-all">
            <span class="sr-only">Next</span>
            <svg class="size-5 md:size-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>